import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getFileTypeIcon, getFileTypeLabel } from './utils/ManageDocumentUtils';

interface Iprops {
    mimeType?: string;
    className?: string;
}

// Colorized file-type glyph; per-type colors live in ManageDocumentLibrary.less
const FileTypeIcon: React.FC<Iprops> = ({ mimeType, className }) => (
    <span
        className={`file-type-icon ${getFileTypeIcon(mimeType)}${
            className ? ` ${className}` : ''
        }`}
        title={getFileTypeLabel(mimeType)}
    >
        <FontAwesomeIcon icon={['far', getFileTypeIcon(mimeType)] as any} />
    </span>
);

export default FileTypeIcon;
